module.exports = __webpack_public_path__ + "static/media/banner-servicios-mobile.66b1d084.png";